import React, { useState, useRef } from "react";
import { Grid, Divider, Typography, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import { useSelector } from "react-redux";
import { useAuth } from "../../../../../contexts/AuthContext";

import InfoCard from "./InfoCard";

import Background from "../../../../../univbackground.jpg";

const univ = [
  { id: 1, name: "National University of Singapore", code: "NUS" },
  { id: 2, name: "Nanyang Technological University", code: "NTU" },
  { id: 3, name: "Singapore Management University", code: "SMU" },
  { id: 4, name: "Singapore Institute of Management", code: "SIM" },
  { id: 5, name: "Nanyang Academy of Fine Arts", code: "NAFA" },
  { id: 6, name: "LASALLE College of the Arts", code: "LASALLE" },
];

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  search: {
    marginBottom: theme.spacing(2),
  },
  saveTitle: {
    marginTop: theme.spacing(2),
  },
}));

export default function DashboardTab() {
  const {currentUser} = useAuth();
  const classes = useStyles();
  const [filteredData, setFilteredData] = useState([]);
  const query = useRef();
  const bookmarkUniv = useSelector((state) => state.bookmark.bookmarkList);
  const univBookmarkFilter = univ.filter((value) => {
    return bookmarkUniv.includes(value.name);
  })

  const handleSearch = (event) => {
    event.preventDefault();
    const searchWord = query.current.value ? query.current.value : "";
    if (searchWord === "") {
      setFilteredData([]);
    } else {
      const newFilter = univ.filter((value) => {
        return value.name.toLowerCase().includes(searchWord.toLowerCase());
      });
      //console.log(newFilter);
      setFilteredData(newFilter);
    }
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h4" color="textPrimary" gutterBottom>
        List of Universities
      </Typography>
      <Divider className={classes.divider} />
      <form onSubmit={handleSearch}>
        <Autocomplete
          className={classes.input}
          id="dashboard-search-bar"
          freeSolo
          options={univ.map((option) => option.name)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search University"
              variant="outlined"
              className={classes.search}
              inputRef={query}
            />
          )}
        />
      </form>
      {filteredData.length !== 0 && (
        <div>
          <Typography variant="h5" gutterBottom>
            Search Result
          </Typography>
          <Grid container spacing={2}>
            {filteredData.map((univnames) => (
              <Grid item key={univnames.id} xs={6}>
                <InfoCard
                  name={univnames.name}
                  code={univnames.code}
                  image={Background}
                  uid={currentUser.uid}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      )}
      <Typography variant="h5" gutterBottom className={classes.saveTitle}>
        Bookmarked Universities
      </Typography>
      <Grid container spacing={2}>
        {univBookmarkFilter.map((univnames) => (
          <Grid item key={univnames.id} xs={6}>
            <InfoCard
              name={univnames.name}
              code={univnames.code}
              image={Background}
              uid={currentUser.uid}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
